// ----------------------------------------------------------------------------
// Form
// ---------------------------------------------------------------------------- 

window.addEventListener('DOMContentLoaded', function(e) {
    var floatingLabels = document.querySelectorAll('.floating-label');

    floatingLabels.forEach(function(floatingLabel) {
        var input = floatingLabel.querySelector('input');

        // Make the label float when the field is focused
        input.addEventListener('focus', function(e) {
            floatingLabel.classList.add('has-focus');
            floatingLabel.classList.add('is-floating');
        });

        if(input.value) {
            floatingLabel.classList.add('has-focus');
            floatingLabel.classList.add('is-floating');
        }

        // Move the label back on blur, but only if the field is empty
        input.addEventListener('blur', function(e) {
            floatingLabel.classList.remove('has-focus');
            
            if(e.target.value == 0) {
                floatingLabel.classList.remove('is-floating');
            }
        });
    });
});
